// extracted by mini-css-extract-plugin
export default {"container":"FormRadio_container__bwjw9","item":"FormRadio_item__mJNYx","label":"FormRadio_label__UjF3O"};